import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isMobile } from 'react-device-detect';

/**
 * RowEventCard - displays a past event in a row layout
 * @param {object} props
 * @param {object} props.show - Event data
 * @param {function} props.renderGenreIcon - Function to render genre icon
 * @param {object} props.faMapMarkerAlt - FontAwesome icon for location
 */
export function RowEventCard({ show, renderGenreIcon, faMapMarkerAlt }) {
  if (isMobile) {
    return (
      <div className="past-card past-card--mobile">
        <div className="past-card__imgcol">
          <div className="past-card__img-wrapper">
            <img src={show.main_image} alt="" className="past-card__img" />
          </div>
        </div>
        <div className="past-card__infocol">
          <div className="past-card__daycol">
            <div className="past-card__date-badge">{show.day}</div>
            <span className="past-card__icon--inline">{renderGenreIcon(show)}</span>
          </div>
          <div className="past-card__title">            
            {show.fullname}
          </div>
          <div className="past-card__venue">
            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#e6007a', marginRight: 6 }} />
            {show.venue}
          </div>
        </div>
      </div>
    );
  }
  // Desktop layout
  return (
    <div className="past-card">
      <div className="past-card__imgcol">
        <div className="past-card__img-wrapper">
          <img src={show.main_image} alt="" className="past-card__img" />
        </div>
      </div>
      <div className="past-card__daycol">
        <div className="past-card__date-badge">{show.day}</div>
      </div>
      <div className="past-card__title">
        <span className="past-card__icon--inline">{renderGenreIcon(show)}</span>
        {show.fullname}
      </div>
      <div className="past-card__venue">
        <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#e6007a', marginRight: 6 }} />
        {show.venue}
      </div>
    </div>
  );
}

RowEventCard.propTypes = {
  show: PropTypes.object.isRequired,
  renderGenreIcon: PropTypes.func.isRequired,
  faMapMarkerAlt: PropTypes.object.isRequired,
}; 